import {
  Box,
  Button,
  CircularProgress,
  Drawer,
  DrawerProps,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { ReactNode } from "react";

import { MediumCustomIcon } from "../../layer00";

export type InformationDrawerLayoutProps = {
  isVisible: boolean;
  loading?: boolean;
  handleClose: () => void;
  headerActionButton: ReactNode | null;
  startIcon?: ReactNode;
  cancelButton?: {
    text: string;
    handleClick: () => void;
  };
  successButton?: {
    text: string;
    handleClick: () => void;
  };
  title?: string;
  subTitle?: string;
};

export const InformationDrawerLayout = (
  props: InformationDrawerLayoutProps & Partial<DrawerProps>
) => {
  return (
    <Drawer
      anchor="right"
      onClick={(e) => e.stopPropagation()}
      open={props.isVisible}
      onClose={() => props.handleClose()}
      SlideProps={{ appear: true }}
      PaperProps={{
        className: "bg-white",
        sx: {
          width: {
            xs: "100%",
            sm: "51rem",
          },
        },
      }}
    >
      <Stack
        paddingX="2rem"
        paddingTop="1.25rem"
        direction="row"
        columnGap=".75rem"
        justifyContent="space-between"
        alignItems="start"
      >
        {props.startIcon}
        <Stack flex="1 1 0" rowGap=".25rem">
          {props.title && (
            <Typography variant="modalTitle">{props.title}</Typography>
          )}
          {props.subTitle && (
            <Typography variant="modalSubtitle">{props.subTitle}</Typography>
          )}
        </Stack>
        {props.headerActionButton}
        <IconButton
          sx={(theme) => ({
            border: "none",
            color: theme.palette.secondary.main,
          })}
          onClick={() => props.handleClose()}
        >
          <MediumCustomIcon icon="CLOSE" />
        </IconButton>
      </Stack>

      {/* MESSAGE */}
      <Box padding={0} display="block">
        {props.children}
      </Box>

      {/* Action Buttons */}
      <Stack direction="row" columnGap=".5rem" justifyContent="space-between">
        {props.cancelButton && !props.loading && (
          <Button
            variant="outlined"
            onClick={() => props.cancelButton?.handleClick()}
            fullWidth
          >
            {props.cancelButton.text}
          </Button>
        )}
        {!props.loading && props.successButton && (
          <Button
            variant="contained"
            color="primary"
            onClick={() => props.successButton?.handleClick()}
            fullWidth
          >
            {props.successButton.text}
          </Button>
        )}

        {props.loading && <CircularProgress />}
      </Stack>
    </Drawer>
  );
};
